import React, {forwardRef} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";

const CitiesItemBrowser = forwardRef(({...restProps}, ref) => {

    function getItemSubtitle(item) {
        const refsData = restProps.refsData;

        if (item.is_region_city)
            return refsData?.countries?.[item.country_id]?.name ?? "?";

        const regionName = refsData?.regions?.[item.region_id]?.name ?? "?";
        const countryName = refsData?.countries?.[refsData?.regions?.[item.region_id]?.country_id]?.name ?? "?";

        return `${countryName}, ${regionName}`;
    }

    function getItemUptitle(item) {
        return item.is_region_city ? "город-регион" : undefined;
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemSubtitleFunc={getItemSubtitle}
            getItemUptitleFunc={getItemUptitle}
        />
    );
});

export default CitiesItemBrowser;